module.exports = __webpack_public_path__ + "img/instagram.ee421da1.svg";